<template>
    <div class="container" :class="{'fullscreen': fullscreen}">
        <template v-if="loaded">
        <div class="row justify-content-center">
            <div class="col-12 px-1 mb-2">
                <div class="card">
                    <div class="card-header">
                        <button v-if="!fullscreen" type="button" class="btn btn-secondary btn-sm back-button align-middle" @click="goBack">
                            <i class="fas fa-chevron-left"></i>
                        </button>
                        <h4 class="ml-2 mb-0 d-inline-block align-middle">{{ group.title }}</h4>
                        <div class="d-inline-block float-right">
                            <button v-if="moreTimes" @click="showMore" class="btn btn-sm btn-secondary mx-1">
                                <i class="fas fa-plus"></i> Display More
                            </button>
                            <button @click="fullscreenToggle" class="btn btn-sm btn-secondary mx-1 d-none d-lg-inline-block">
                                <i class="fas" :class="{'fa-expand': !fullscreen, 'fa-compress': fullscreen}"></i> <template v-if="fullscreen">Exit</template><template v-else>Enter</template> Fullscreen
                            </button>
                            <template v-if="authUser && !fullscreen">
                                <button @click="deleteGroup" type="button" class="btn btn-sm btn-danger"><i class='far fa-trash-alt'></i> Delete Group</button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <template v-for="(time, i) in topTimes">
                <template v-if="time.board.type === 'time'">
                    <time-card @edit="edit" @editfinished="editFinished" @delete="loadGroup()" :fullscreen="fullscreen" :time="time" :key="time.id" :position="i+1" :viewLevel="'group'"></time-card>
                </template>
                <template v-else>
                    <score-card @edit="edit" @editfinished="editFinished" @delete="loadGroup()" :fullscreen="fullscreen" :time="time" :key="time.id" :position="i+1" :viewLevel="'group'"></score-card>
                </template>
            </template>
            <permalink v-if="!fullscreen" type="group" :id="id"></permalink>
            <div class="col px-1 mb-2" :class="{'d-none': fullscreen}">
                <div class="card">
                    <div class="card-header">Boards</div>

                    <div class="card-body">
                        <div ref="boards-table"></div>
                    </div>
                </div>
            </div>
            <div v-if="authUser" class="col-md-12 px-1 mb-2">
                <div class="card">
                    <div class="card-header"><h4 class="mb-0 align-middle">Create Board</h4></div>

                    <div class="card-body">
                        <form class="form-inline">
                                <div class="form-group mr-2">
                                    <label for="title" class="sr-only">Board Title</label>
                                    <input type="text" name="title" id="title" v-model="newBoard.title" placeholder="Board Title" class="form-control" :class="{'is-invalid': !valid}">
                                </div>
                                <div class="form-group mr-2">
                                    <label for="details" class="sr-only">Board Details</label>
                                    <input type="text" name="details" id="details" v-model="newBoard.description" placeholder="Board Details" class="form-control">
                                </div>
                                <div class="form-group mr-2" style="border: 1px solid #ccc; padding: 5px;">
                                    <label for="type" class="sr-only">Board Type</label>
                                    <div class="form-check form-check-inline">
                                        <input type="radio" class="form-check-input" name="type" id="inlineRadio1" value="time" v-model="newBoard.type" ref="typeRadio1">
                                        <label class="form-check-label" for="inlineRadio1">Time</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input type="radio" class="form-check-input" name="type" id="inlineRadio2" value="score" v-model="newBoard.type" ref="typeRadio2">
                                        <label class="form-check-label" for="inlineRadio2">Score</label>
                                    </div>
                                </div>
                                <div class="form-group mr-2" style="border: 1px solid #ccc; padding: 5px;">
                                    <label for="private" class="sr-only">Board Visability</label>
                                    <div class="form-check form-check-inline">
                                        <input type="radio" class="form-check-input" name="private" id="inlineRadio1" value="0" v-model="newBoard.private">
                                        <label class="form-check-label" for="inlineRadio1">Public</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input type="radio" class="form-check-input" name="private" id="inlineRadio2" value="1" v-model="newBoard.private">
                                        <label class="form-check-label" for="inlineRadio2">Hidden</label>
                                    </div>
                                </div>
                                <button @click="createBoard" type="button" class="btn btn-primary">Add Board</button>
                            </form>
                    </div>
                </div>
            </div>
        </div>
        </template>
        <template v-else>
            <div class="col px-1">
                <div class="card">
                    <div class="card-header">Loading Data</div>

                    <div class="card-body">
                        <div class="progress">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            default: false
        },
    },
    data() {
        return {
            group: {},
            times: [],
            disableType: false,
            updateInterval: false,
            boardSize: 10,
            boardTable: false,
            loaded: false,
            fullscreen: false,
            authUser: window.authUser || false,
            modal: window.modal,
            valid: true,
            newBoard: {
                title: null,
                description: null,
                group_id: this.id,
                private: 0,
                type: "time",
            },
            base: {
                title: null,
                description: null,
                group_id: this.id,
                private: 0,
                type: "time",
            },
        }
    },
    computed: {
        topTimes() {
            let timesList = Object.assign([], this.times);
            timesList.sort((a,b) => {
                if (a.points > b.points) {
                    return -1;
                }

                if (a.points < b.points) {
                    return 1;
                }

                if (a.time < b.time) {
                    return -1;
                }
                if (a.time > b.time) {
                    return 1;
                }

                if (a.recorded_date < b.recorded_date) {
                    return -1;
                }
                if (a.recorded_date > b.recorded_date) {
                    return 1;
                }

                return 0;
            });

            let top = timesList.slice(0, this.boardSize);

            return top;
        },
        moreTimes() {
            return this.times.length > this.boardSize;
        },
    },
    methods: {
        goBack() {
            this.$emit("back");
        },
        showMore() {
            this.boardSize = this.boardSize + 10;
        },
        edit() {
            this.editing = true;
        },
        editFinished() {
            this.editing = false;
            this.loadGroup();
        },
        loadGroup(firstRun) {
            if (this.editing) {
                return;
            }
            axios.get(`/group/${this.id}`)
                .then((result) => {
                    this.group = result.data;
                    this.group.boards.forEach((board) => {
                        if (firstRun) {
                            this.base.type = board.type;
                            this.newBoard.type = board.type;

                            setTimeout(() => {
                                this.$refs['typeRadio1'].disabled = true;
                                this.$refs['typeRadio2'].disabled = true;
                            }, 100);
                        }
                        board.scores.forEach((score) => {
                            let i = this.times.findIndex((time) => {
                                return time.id === score.id;
                            })

                            if (i != -1) {
                                this.$set(this.times, i, score);
                            } else {
                                this.$set(this.times, this.times.length, score);
                            }
                        })
                    })

                    document.title = `The Extreme Airsoft - Scoreboard - Group: ${this.group.title}`;

                    this.loaded = true;

                    this.loadTable();
                })
                .catch((err) => {
                    console.error(err);
                })
        },
        loadTable() {
            if (!this.boardTable) {
                setTimeout(() => {
                    this.boardTable = new Tabulator(this.$refs['boards-table'], {
                        layout: 'fitColumns',
                        data: this.group.boards,
                        columns: [
                            {
                                title: 'Board',
                                field: 'title',
                            },
                            {
                                title: 'Details',
                                field: 'description',
                            },
                        ],
                        rowClick:(e, row) => {
                            let boardId = row.getData().id;
                            this.$emit('board', boardId);
                        },
                    });
                }, 200);
            } else {
                this.boardTable.replaceData(this.group.boards);
            }
        },
        fullscreenToggle() {
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) { /* Safari */
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) { /* IE11 */
                    document.msExitFullscreen();
                }
            } else {
                var elem = document.getElementsByTagName('html')[0];
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.webkitRequestFullscreen) { /* Safari */
                    elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) { /* IE11 */
                    elem.msRequestFullscreen();
                }
            }

            this.fullscreen = !this.fullscreen;
        },
        validate() {
            console.log(this.newBoard);
            return (this.newBoard.title && this.newBoard.title.length);
        },
        createBoard() {
            this.valid = true;
            if (this.validate()) {
                axios.post('/board/add', this.newBoard)
                    .then((result) => {
                        this.reset();
                        this.$emit('board', result.data.id);
                    })
                    .catch((err) => {
                        console.error("Create Error:", err);
                    })
            } else {
                this.valid = false;
            }
        },
        reset() {
            this.newBoard = Object.assign({}, this.base);
        },
        deleteGroup() {
            console.info('Delete group', window.location.origin);
            this.modal.title = 'Delete Group';
            this.modal.body = `Are you sure that you want to delete group ${this.group.title}?`;
            this.modal.confirm(() => {
                axios.delete(`/group/delete/${this.group.id}`)
                .then((response) => {
                    window.location.href = window.location.origin;
                })
                .catch((e) => {
                    console.error(e);
                })
            });
        },
        exitHandler() {
            if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
                this.fullscreen = false;
            }
        },
    },
    mounted() {
        this.loadGroup(true);

        this.updateInterval = setInterval(this.loadGroup.bind(this), 10 * 1000);

        document.addEventListener('fullscreenchange', this.exitHandler.bind(this));
        document.addEventListener('webkitfullscreenchange', this.exitHandler.bind(this));
        document.addEventListener('mozfullscreenchange', this.exitHandler.bind(this));
        document.addEventListener('MSFullscreenChange', this.exitHandler.bind(this));
    },
    beforeDestroy() {
        clearInterval(this.updateInterval);
        this.loaded = false;

        document.removeEventListener('fullscreenchange', this.exitHandler.bind(this));
        document.removeEventListener('webkitfullscreenchange', this.exitHandler.bind(this));
        document.removeEventListener('mozfullscreenchange', this.exitHandler.bind(this));
        document.removeEventListener('MSFullscreenChange', this.exitHandler.bind(this));
    },
}
</script>